export const GREEDY_FEE = {
  nickname: 'PRODUCTS.GREEDY_FEE.nickname',
  icon:'greedy-fee'
};
